// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__OT6vb","notes":"Notes_notes__2Tp4J","note":"Notes_note__2sPIp","markdown":"Notes_markdown__37GpW"};